import { GpsType } from '../../../../../global/components/layout/layout-models';
import { AdminGhlPendingEnrollment } from '../member/models/member-coverage-model';

export interface NewHireConfirmationModel {
	statusCode: string;
	alertType: string;
	alertDescription: string;
	title: string;
	description: string;
	nextStep: string;
	buttonText?: string;
	buttonLink?: string;
	gpsType?: GpsType;
}

export interface DownloadFile {
	name: string;
	url: string;
}

export enum ConfirmationStatusCode {
	DEFAULT = 'default',
	NH_BY_DIO = 'nh_by_dio',
	NH_MEMBER = 'nh_member',
	NEW_PARTICIPANT = 'new_participant',
	PENDING = 'pending',
	APPROVER_APPROVE = 'approver_approve',
	APPROVER_REJECT = 'approver_reject',
	UPDATE_ENROLLMENT = 'update_enrollment',
	UPDATE_ENROLLMENT_NO_APPROVAL = 'update_enrollment_no_approval',
}

export interface NewHireSubmissionConfirmationWarning {
	message: string;
	warnings: string[];
}

export interface ConfirmationEnrolledPlanDto {
	health: boolean;
	layDc: boolean;
	layDb: boolean;
	clergyDb: boolean;
	rsvp: boolean;
	groupLife: boolean;
	disability: boolean;
}

export interface DioApproverConfirmationPageState {
	isDioApproverConfirmationPage: boolean,
	approvedState: boolean,
	currentForminfo?: AdminGhlPendingEnrollment,
}



export interface NewHireConfirmationRedirectModel {

	apiWarning: NewHireSubmissionConfirmationWarning;
	enrolledPlanDto?: ConfirmationEnrolledPlanDto;
	dioApproverConfirmationPage?: DioApproverConfirmationPageState;
}

